import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";

const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

const getTopicsSuccess = (data) => {
  const noTopics = isObjectEmpty(data.Data)
  return {
    type: actionTypes.GET_TOPICS,
    payload: {
      topics: noTopics ? [] : data.Data,
    },
  };
};

export const getTopics = (payload) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/GetTopics`, payload)
    .then((response) => {
      if (response) {
        dispatch(getTopicsSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};





